var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"principal_lti_container",attrs:{"fluid":""}},[_c('div',[_c('b-tabs',{attrs:{"content-class":"mt-3"}},[_c('b-tab',{attrs:{"title":_vm.$t('reviews.list'),"active":""}},[_c('Revisiones')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }